import axios from "axios";

// Use same-origin API (nginx proxy)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// 🔥 ADD THIS: attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("showroom_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Optional helpers
export const resolveAssetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export const trackEvent = (event, data = {}) => {
  console.log("Track:", event, data);
};
